var React = require('react');

function PullUpChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.2891 0.094512C32.3217 -0.188621 33.4768 0.185865 33.8691 0.93095C34.2615 1.67603 33.7425 2.50957 32.71 2.7927L17.71 6.90588C17.2523 7.03137 16.7468 7.03137 16.2891 6.90588L1.28913 2.7927C0.256594 2.50957 -0.262366 1.67603 0.129997 0.93095C0.522361 0.185865 1.67747 -0.188621 2.71 0.094512L16.9996 4.01288L31.2891 0.094512Z","fill":"#C8E5EB"}));
}

PullUpChevron.defaultProps = {"width":"34","height":"7","viewBox":"0 0 34 7","fill":"none"};

module.exports = PullUpChevron;

PullUpChevron.default = PullUpChevron;
